/**
 * Utility functions for handling pagination
 */

/**
 * Create pagination change handler
 */
export const createPaginationHandler = (
  setCursor,
  setPageNumber,
  setCriteria,
  user,
) => {
  return (cursor, pageNumber) => {
    setCursor(cursor);
    setPageNumber(pageNumber);
    setCriteria({
      ...cursor,
      filter: [{ customerId: { equals: user.customerId } }],
    });
  };
};

/**
 * Create next page handler
 */
export const createNextPageHandler = (
  data,
  changePage,
  pageNumber,
  NUM_ON_PAGE,
) => {
  return () => {
    if (data?.endCursor) {
      changePage({ first: NUM_ON_PAGE, after: data.endCursor }, pageNumber + 1);
    }
  };
};

/**
 * Create previous page handler
 */
export const createPreviousPageHandler = (
  pageNumber,
  changePage,
  data,
  NUM_ON_PAGE,
) => {
  return () => {
    if (pageNumber > 1) {
      changePage(
        { last: NUM_ON_PAGE, before: data.startCursor },
        pageNumber - 1,
      );
    }
  };
};
